<div *ngIf="!loader" fxFlexFill>
    <mat-tab-group fxFlex mat-stretch-tabs>
        <mat-tab [label]="id_name">
            <div class="layout-padd" fxLayout="column" fxLayoutGap="20px">
                <div *ngIf="merchantTerms; else noConditions" [innerHTML]="merchantTerms"></div>
            </div>
        </mat-tab>
        
        <mat-tab *ngIf="!domainUser">
            <ng-template mat-tab-label>
                <img src="assets/img/logo/logo-fulle.png" style="height: 30px; width: auto;" alt="Fulle">
            </ng-template>
            <div class="layout-padd scrolled" fxLayout="column" fxLayoutGap="20px">
                <div [innerHTML]="fulleTerms"></div>
            </div>
        </mat-tab>
    </mat-tab-group>
</div>

<ng-template #noConditions>
    <div class="fill-rest" fxLayoutAlign="center center">
        <span class="mat-subheading-1 boldest">{{'noconditionsge'|translate}}</span>
    </div>
</ng-template>

<app-popup-loader [flagLoading]="loader" [statusMessage]="loaderMessage" [size]="30"></app-popup-loader>